export const SET_STAGE = 'SET_STAGE';
export function setStage(stage) {
  return {
    type: SET_STAGE,
    stage,
  };
}
